// frontend/src/components/Toast.jsx
// Toast notification display component

import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle, AlertCircle, Info } from 'lucide-react';
import '../styles/Toast.css';

const Toast = ({ toasts, onRemove }) => {
  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return <CheckCircle size={20} />;
      case 'error':
        return <AlertCircle size={20} />;
      case 'warning':
        return <AlertCircle size={20} />;
      default:
        return <Info size={20} />;
    }
  };

  const getColor = (type) => {
    switch (type) {
      case 'success':
        return '#10b981'; // Green
      case 'error':
        return '#ef4444'; // Red
      case 'warning':
        return '#f59e0b'; // Orange
      default:
        return '#3b82f6'; // Blue
    }
  };

  return (
    <div className="toast-container">
      <AnimatePresence>
        {toasts.map((toast) => (
          <motion.div
            key={toast.id}
            className={`toast toast-${toast.type}`}
            initial={{ opacity: 0, y: -20, x: 20 }}
            animate={{ opacity: 1, y: 0, x: 0 }}
            exit={{ opacity: 0, y: -20, x: 20 }}
            transition={{ duration: 0.3 }}
            style={{ borderLeftColor: getColor(toast.type) }}
          >
            <div className="toast-content">
              <div className="toast-icon" style={{ color: getColor(toast.type) }}>
                {getIcon(toast.type)}
              </div>
              <div className="toast-message">
                {toast.message}
              </div>
            </div>
            <button
              className="toast-close"
              onClick={() => onRemove(toast.id)}
              aria-label="Close"
            >
              <X size={18} />
            </button>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default Toast;